// StalenessIndicator — shows how old the data is with visual decay
interface StalenessIndicatorProps {
  lastSeenAt: string;
  thresholds?: { stale: number; critical: number };
}

export function StalenessIndicator({
  lastSeenAt,
  thresholds = { stale: 30, critical: 90 },
}: StalenessIndicatorProps) {
  const date = new Date(lastSeenAt);
  const now = new Date();
  const diffDays = Math.floor((now.getTime() - date.getTime()) / (1000 * 60 * 60 * 24));

  const level = diffDays >= thresholds.critical
    ? 'critical'
    : diffDays >= thresholds.stale
      ? 'stale'
      : 'fresh';

  const label = diffDays === 0
    ? 'today'
    : diffDays === 1
      ? '1 day ago'
      : `${diffDays} days ago`;

  return (
    <span className={`staleness-indicator ${level}`} title={`Last seen: ${date.toLocaleString()}`}>
      {level === 'critical' && '⚠ '}
      {label}
    </span>
  );
}
